/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_Faq_Q4Inputs */

const en_guide_json_syntax_errors_faq_q4 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the fastest way to find the exact error?`)
};

const ko_guide_json_syntax_errors_faq_q4 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정확한 오류 위치를 가장 빨리 찾는 방법은?`)
};

const ja_guide_json_syntax_errors_faq_q4 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正確なエラー箇所を最速で見つける方法は?`)
};

/**
* | output |
* | --- |
* | "What is the fastest way to find the exact error?" |
*
* @param {Guide_Json_Syntax_Errors_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_faq_q4 = /** @type {((inputs?: Guide_Json_Syntax_Errors_Faq_Q4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_Faq_Q4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_faq_q4(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_faq_q4(inputs)
	return ja_guide_json_syntax_errors_faq_q4(inputs)
});